import React, { useEffect, useState } from 'react';
import {
  Button,
  Paper,
  Grid,
  Avatar,
  TextField,
  FormControlLabel,
  Checkbox,
  CardHeader,
} from '@material-ui/core';
import { useStyles } from './style';
import DoctariModal from '../../components/Modal';
import { DropzoneArea } from 'material-ui-dropzone';
import { connect } from 'react-redux';
import { APPOINTMENTS, BASE_PAYMENT, AGENDA } from '../../utils/urls';
import { userActionsTypes } from '../../redux/user/actions';
import { appointmentActionsTypes } from '../../redux/appointment/actions';
import AutocompleteInfo from '../../components/AutocompleteInfo';
import { useHistory, useLocation } from 'react-router';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';

function Appointment({
  getUser,
  createAppointment,
  appointmentsData,
  session,
  userData,
  addUserInfo,
  deleteUserInfo,
  deleteMessages,
  createInfo,
  uploadAppointmentFiles,
  uploadConsentFile,
  deleteAttachmentMessages,
  getPatients,
  doctors,
  deleteSchedule,
  getMpPreference,
}) {
  const history = useHistory();
  const location = useLocation();
  const styles = useStyles();
  const [attachmentModalOpen, setAttachmentModalOpen] = useState(false);
  const [uploadingAttachmentConsent, setUploadingAttachmentConsent] =
    useState(false);
  const [uploadingAttachmentStudies, setUploadingAttachStudies] =
    useState(false);
  const [createAppointmentModalOpen, setCreateAppointmentModalOpen] =
    useState(false);
  const [checked, setChecked] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [consentFile, setConsentFile] = useState(null);
  const [input, setInput] = useState('');

  const isAssistant = session.userType == 'assistant';
  const isPatient = session.userType == 'patient';

  // const [stateAppointment, setStateAppointment] = useState({
  //   dateAppointment: !isAssistant
  //     ? location.state.schedule.start
  //     : appointmentsData.scheduleCreated.start,
  //   doctorFullName: !isAssistant
  //     ? location.state.schedule.doctor.full_name
  //     : doctors.selectDoctor.full_name,
  //   doctorPictureProfile: isAssistant
  //     ? doctors.selectDoctor.profile_picture
  //       ? doctors.selectDoctor.profile_picture.url
  //       : null
  //     : location.state.schedule.doctor.profile_picture
  //     ? location.state.schedule.doctor.profile_picture.url
  //     : null,
  //   doctorSpecialty: isAssistant
  //     ? doctors.selectDoctor.specialty.name
  //     : location.state.schedule.doctor.specialty.name,
  // });
  // const {
  //   dateAppointment,
  //   doctorFullName,
  //   doctorPictureProfile,
  //   doctorSpecialty,
  // } = stateAppointment;
  const [patientSelected, setPatient] = useState({
    patient: null,
    medications: null,
    allergies: null,
    diseases: null,
  });

  const [injuredArea, setInjuredArea] = useState('');
  const [physicalExamination, setPhysicalExamination] = useState('');
  const [symptoms, setSymptoms] = useState('');
  const [symptomsTime, setSymptomsTime] = useState('');
  const [spo2, setSpo2] = useState('');
  const [glucose, setGlucose] = useState('');
  const [systolicPressure, setSystolicPressure] = useState('');
  const [diastolicPressure, setDiastolicPressure] = useState('');
  const [heartRate, setHeartRate] = useState('');
  const [temperature, setTemperature] = useState('');
  const [respiratoryRate, setRespiratoryRate] = useState('');
  const [expNum, setExpNum] = useState('');


  const goPayment = () => {
    history.push({
      pathname: `${BASE_PAYMENT}${appointmentsData.appointmentCreated.id}`,
      state: {
        appointmentDate: location.state.schedule.start,
        doctorName: location.state.schedule.doctor.full_name,
      },
    });
    return () => deleteAttachmentMessages();
  };

  const goPaymentMP = () => {
    // handleMpModal
    // checkout = window.mp.checkout({
    //   preference: {
    //     id: userData.mpPreference.id,
    //   },
    // });
    // console.log('PREFERENCE ID', userData.mpPreference.id);
    // checkout.open();
    // Now we gonna use mp redirect instead of modal (check paymentForm for more comments on this)
    if (userData?.mpPreference?.init_point) {
      history.push(APPOINTMENTS);
      return () => deleteAttachmentMessages();
    }
  };

  // when the appointment files are added  we go to payment page and pass the appointment id
  useEffect(() => {
    if (
      appointmentsData.success.uploadFiles &&
      // appointmentsData.success.consentFile &&
      buttonClicked &&
      !isAssistant
    ) {
      const body = {
        title: 'Appointment',
        price: 200,
        appointment: appointmentsData?.appointmentCreated.id,
      };
      getMpPreference(body);
    } else if (isAssistant && buttonClicked) {
      history.push(AGENDA);
    }
  }, [appointmentsData.success.uploadFiles]);
  // when the appointment is created we upload the attachments

  useEffect(() => {
    goPaymentMP();
  }, [userData?.mpPreference?.init_point]);

  useEffect(() => {
    if (
      appointmentsData.success.genericMessage ===
        'Appointment creado con exito' &&
      buttonClicked &&
      consentFile
    ) {
      const body = {
        file: consentFile,
        fileType: consentFile.type,
        appointmentId: appointmentsData?.appointmentCreated.id,
      };
      uploadConsentFile(body);
    } else if (
      buttonClicked &&
      (appointmentsData.success.genericMessage ===
        'Appointment creado y consentimiento subido con exito' ||
        appointmentsData.success.genericMessage ===
          'Appointment creado y adjuntos subidos con exito' ||
        (appointmentsData.success.genericMessage ===
          'Appointment creado con exito' &&
          !consentFile))
    ) {
      if (attachments.length === 0 && !isAssistant) {
        const body = {
          title: 'Appointment',
          price: 200,
          appointment: appointmentsData?.appointmentCreated.id,
        };
        getMpPreference(body);
      } else if (attachments.length > 0) {
        const formDataAppointment = new FormData();
        for (let i = 0; i < attachments.length; i++) {
          formDataAppointment.append(`file${i}`, attachments[i]);
        }
        const body = {
          files: formDataAppointment,
          appointmentId: appointmentsData?.appointmentCreated.id,
        };
        uploadAppointmentFiles(body);
      } else if (isAssistant) {
        history.push(AGENDA);
      }
    }
  }, [appointmentsData.success.genericMessage]);

  useEffect(() => {
    getUser(session.userType, session.id);
    if (isAssistant) {
      getPatients([], []);
    }

    deleteMessages();
    deleteAttachmentMessages();
  }, []);

  useEffect(() => {
    if (!isAssistant && userData.user) {
      setPatient({
        patient: userData.user,
        medications: userData.user.medications,
        allergies: userData.user.allergies,
        diseases: userData.user.diseases,
      });
    }
  }, [userData]);

  const { medications, allergies, diseases } = userData;

  const getUrlAndId = (type, isForDelete) => {
    let dataType = {};
    if (type === 'medications') {
      dataType = {
        id: 'medication_id',
        url: isForDelete ? 'delete_medication' : 'patient_medication',
      };
    } else if (type === 'diseases') {
      dataType = {
        id: 'disease_id',
        url: isForDelete ? 'delete_disease' : 'patient_disease',
      };
    } else if (type === 'allergies') {
      dataType = {
        id: 'allergie_id',
        url: isForDelete ? 'delete_allergie' : 'patient_allergie',
      };
    }
    return dataType;
  };

  const handleUserMedication = (isNew, med, isForDelete = false) => {
    const infoToUpdate = 'medications';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: med.name }, data);
      } else {
        addUserInfo(infoToUpdate, data, med);
      }
    } else {
      deleteUserInfo(infoToUpdate, data, med.id);
    }
  };

  const handleUserDisease = (isNew, disease, isForDelete = false) => {
    const infoToUpdate = 'diseases';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: disease.name }, data);
      } else {
        addUserInfo(infoToUpdate, data, disease);
      }
    } else {
      deleteUserInfo(infoToUpdate, data, disease.id);
    }
  };

  const handleUserAllergie = (isNew, allergie, isForDelete = false) => {
    const infoToUpdate = 'allergies';
    const data = getUrlAndId(infoToUpdate, isForDelete);
    if (!isForDelete) {
      if (isNew) {
        createInfo(infoToUpdate, { name: allergie.name }, data);
      } else {
        addUserInfo(infoToUpdate, data, allergie);
      }
    } else {
      deleteUserInfo(infoToUpdate, data, allergie.id);
    }
  };

  const addInformation = {
    handleUserMedication,
    handleUserAllergie,
    handleUserDisease,
  };

  const handleInjuredAreaChange = (e) => {
    setInjuredArea(e.target.value);
  };

  const handlePhysicalExaminationChange = (e) => {
    setPhysicalExamination(e.target.value);
  };

  const handleSymptomsChange = (e) => {
    setSymptoms(e.target.value);
  };

  const handleSymptomsTimeChange = (e) => {
    setSymptomsTime(e.target.value);
  };

  const handleSpo2Change = (e) => {
    setSpo2(e.target.value);
  };

  const handleGlucoseChange = (e) => {
    setGlucose(e.target.value);
  };

  const handleSystolicPressureChange = (e) => {
    setSystolicPressure(e.target.value);
  };

  const handleDiastolicPressureChange = (e) => {
    setDiastolicPressure(e.target.value);
  };

  const handleHeartRateChange = (e) => {
    setHeartRate(e.target.value);
  };

  const handleTemperatureChange = (e) => {
    setTemperature(e.target.value);
  };

  const handleExpNumChange = (e) => {
    setExpNum(e.target.value)
  }

  const handleRespiratoryRateChange = (e) => {
    setRespiratoryRate(e.target.value); 
  }

  const handleAttachmentsChange = (files) => {
    if (files.length !== 0) {
      if (uploadingAttachmentConsent) {
        setConsentFile(files[0]);
      } else if (uploadingAttachmentStudies) {
        setAttachments(files);
      }
      console.log(files);
    }
  };

  const handleInputCHange = (e) => {
    setInput(e.target.value);
  };

  const handleCheckChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleCreateAppointment = () => {
    setButtonClicked(true);
    createAppointment(
      location.state.schedule.id,
      0, // hardcoded price
      input,
      location.state.schedule.doctor.id,
      patientSelected.patient.id,
      session.accessToken,
      patientSelected.patient.allergies,
      patientSelected.patient.medications,
      patientSelected.patient.diseases,
      injuredArea,
      physicalExamination,
      symptoms,
      symptomsTime,
      spo2,
      glucose,
      systolicPressure,
      diastolicPressure,
      heartRate,
      temperature,
      expNum,
      respiratoryRate,
      consentFile
    );
    setCreateAppointmentModalOpen(false);
  };

  const handleAttachConsent = () => {
    setAttachmentModalOpen(true);
    setUploadingAttachmentConsent(true);
    setUploadingAttachStudies(false);
  };

  const handleAttachStudies = () => {
    setAttachmentModalOpen(true);
    setUploadingAttachmentConsent(false);
    setUploadingAttachStudies(true);
  };

  const handleAttachmentsAccept = () => {
    setUploadingAttachmentConsent(false);
    setUploadingAttachStudies(false);
    setAttachmentModalOpen(false);
  };

  const handleAttachCancel = () => {
    if (uploadingAttachmentConsent) {
      setConsentFile(null);
    } else if (uploadingAttachmentStudies) {
      setAttachments([]);
    }
    setUploadingAttachmentConsent(false);
    setUploadingAttachStudies(false);
    setAttachmentModalOpen(false);
  };

  const handleSetPatientInfo = (value) => {
    if (value == null) {
      setPatient({
        patient: null,
        medications: null,
        allergies: null,
        diseases: null,
      });
    } else {
      setPatient({
        patient: value,
        medications: value.medications,
        allergies: value.allergies,
        diseases: value.diseases,
      });
    }
  };

  const handleCancelAppointment = () => {
    if (isAssistant) {
      deleteSchedule('token', location.state.schedule.id, false);
      history.push(AGENDA);
    } else {
      history.push(APPOINTMENTS);
    }
  };

  if (!patientSelected) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <DoctariModal
        open={attachmentModalOpen}
        setOpen={(val) => setAttachmentModalOpen(val)}
        title={
          uploadingAttachmentConsent
            ? 'Adjuntar consentimiento'
            : 'Adjuntar estudios'
        }
      >
        <DropzoneArea
          useChipsForPreview={true}
          dropzoneText={
            'Haz click aquí o arrastra tus archivos para adjuntarlos'
          }
          onChange={(files) => handleAttachmentsChange(files)}
          onDelete={(file) => console.log(file)}
          clearOnUnmount={false}
          filesLimit={uploadingAttachmentConsent ? 1 : 3}
          initialFiles={uploadingAttachmentConsent ? consentFile : attachments}
          getFileAddedMessage={(file) => `${file} añadido`}
          getFileRemovedMessage={(file) => `${file} eliminado`}
          getFileLimitExceedMessage={(limit) =>
            `Limite de archivos excedido, el limite es de ${limit} archivos`
          }
        />
        <Button
          style={{ float: 'right', margin: '10px' }}
          variant='contained'
          color='primary'
          disabled={!attachments.length && consentFile === null}
          onClick={handleAttachmentsAccept}
        >
          Aceptar
        </Button>
        <Button
          style={{ float: 'right', margin: '10px' }}
          onClick={handleAttachCancel}
          variant='outlined'
          color='primary'
        >
          Cancelar
        </Button>
      </DoctariModal>

      <DoctariModal
        open={createAppointmentModalOpen}
        setOpen={(val) => setCreateAppointmentModalOpen(val)}
        title={'Importante'}
      >
        <p style={{ margin: '5%' }}>
          <strong>Política de cancelación:</strong> La devolución del dinero de
          la consulta sólo se realiza si la cancelación es hasta 6 horas antes
          del inicio de la misma.
        </p>
        <Button
          style={{ float: 'right', margin: '10px' }}
          variant='contained'
          color='primary'
          onClick={handleCreateAppointment}
        >
          Aceptar
        </Button>
        <Button
          style={{ float: 'right', margin: '10px' }}
          onClick={() => setCreateAppointmentModalOpen(false)}
          variant='outlined'
          color='primary'
        >
          Cancelar
        </Button>
      </DoctariModal>

      <Grid
        container
        direction='column'
        justifyContent='center'
        alignItems='center'
      >
        <Grid
          item
          xs={12}
          md={12}
          justifyContent='space-between'
          className={styles.menuContainer}
        >
          <h2 className={styles.title}>Crear consulta</h2>
          <CardHeader
            avatar={
              <Avatar
                alt='Foto de perfil'
                src={
                  location.state.schedule.doctor.profile_picture
                    ? location.state.schedule.doctor.profile_picture.url
                    : null
                }
                className={styles.avatar}
              />
            }
            title={location.state.schedule.doctor.full_name}
            subheader={location.state.schedule.doctor.specialty.name}
          />
        </Grid>
        <Grid item className={styles.formConteiner}>
          <Paper elevation={8} style={{ padding: '40px 40px' }}>
            <Grid item container spacing={2} className={styles.testContainer}>
              <Grid className={styles.firstPaperContainer}>
                <p>
                  <b>Fecha de consulta:</b>
                  {` ${moment(location.state.schedule.start)
                    .tz(moment.tz.guess())
                    .format('YYYY-MM-DD HH:mm [hs]')}`}
                </p>
              </Grid>
              {isAssistant && (
                <Grid item md={12} xs={12}>
                  {/* <FormControl className={classes.formControl}> */}
                  <Autocomplete
                    disablePortal
                    id='combo-box-demo'
                    options={userData.patients}
                    getOptionLabel={(option) => option.full_name}
                    sx={{ width: 300 }}
                    value={patientSelected.patient}
                    onChange={(e, value) => handleSetPatientInfo(value)}
                    renderInput={(params) => (
                      <TextField {...params} label='Seleccione un paciente' />
                    )}
                  />
                </Grid>
              )}
              <Grid item md={12} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Motivo de la consulta'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleInputCHange}
                />
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <AutocompleteInfo
                  label={'Alergias'}
                  optionList={allergies}
                  valuesSelected={
                    patientSelected?.patient ? patientSelected.allergies : []
                  }
                  setNewValue={(allergie) => {
                    const isNew = true;
                    addInformation.handleUserAllergie(isNew, allergie);
                  }}
                  addValue={(allergie) => {
                    const isNew = false;
                    addInformation.handleUserAllergie(isNew, allergie);
                  }}
                  deleteValue={(allergie) => {
                    const isNew = false;
                    const isForDelete = true;
                    addInformation.handleUserAllergie(
                      isNew,
                      allergie,
                      isForDelete
                    );
                  }}
                  isAssistant={isAssistant}
                />
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <AutocompleteInfo
                  label={'Enfermedades'}
                  optionList={diseases}
                  valuesSelected={
                    patientSelected.patient ? patientSelected.diseases : []
                  }
                  setNewValue={(disease) => {
                    const isNew = true;
                    addInformation.handleUserDisease(isNew, disease);
                  }}
                  addValue={(disease) => {
                    const isNew = false;
                    addInformation.handleUserDisease(isNew, disease);
                  }}
                  deleteValue={(disease) => {
                    const isNew = false;
                    const isForDelete = true;
                    addInformation.handleUserDisease(
                      isNew,
                      disease,
                      isForDelete
                    );
                  }}
                  isAssistant={isAssistant}
                />
              </Grid>
              <Grid item md={6} xs={12} className={styles.paperGridItems}>
                <AutocompleteInfo
                  label={'Medicamentos'}
                  optionList={medications}
                  valuesSelected={
                    patientSelected.patient ? patientSelected.medications : []
                  }
                  setNewValue={(med) => {
                    const isNew = true;
                    addInformation.handleUserMedication(isNew, med);
                  }}
                  addValue={(med) => {
                    const isNew = false;
                    addInformation.handleUserMedication(isNew, med);
                  }}
                  deleteValue={(med) => {
                    const isNew = false;
                    const isForDelete = true;
                    addInformation.handleUserMedication(
                      isNew,
                      med,
                      isForDelete
                    );
                  }}
                  isAssistant={isAssistant}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Número de expediente'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleExpNumChange}
                />
              </Grid>


              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Lesión'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleInjuredAreaChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Examen físico'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handlePhysicalExaminationChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Síntomas'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleSymptomsChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Tiempo de los síntomas'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleSymptomsTimeChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='SPO2 (%)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleSpo2Change}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Glucosa en sangre (mg/dl)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleGlucoseChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Presión Sistólica (mm Hg)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleSystolicPressureChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Presión Diástolica (mm Hg)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleDiastolicPressureChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Frecuencia Cardíaca (ppm)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleHeartRateChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Temperatura (°C)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleTemperatureChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <TextField
                  id='standard-basic'
                  label='Frecuencia Respiratoria (rpm)'
                  variant='standard'
                  style={{ width: '100%' }}
                  className={styles.paperGridItems}
                  onChange={handleRespiratoryRateChange}
                />
              </Grid>

              <div className={styles.forthtPaperContainer}>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        checked={checked}
                        onChange={handleCheckChange}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    }
                    label='Aceptar los términos,condiciones y consentimiento informado.'
                  />
                </Grid>
                <Grid item>
                  <Button
                    variant='outlined'
                    className={styles.buttons}
                    color='primary'
                    style={{ marginRight: '10px' }}
                    onClick={() => handleAttachConsent()}
                  >
                    Adjuntar consentimiento
                  </Button>
                  <Button
                    variant='outlined'
                    className={styles.buttons}
                    color='primary'
                    style={{ marginRight: '10px' }}
                    onClick={() => handleAttachStudies()}
                  >
                    Adjuntar estudios
                  </Button>
                  <Button
                    variant='outlined'
                    className={styles.buttons}
                    color='primary'
                    onClick={handleCancelAppointment}
                  >
                    Cancelar
                  </Button>
                  <Button
                    variant='contained'
                    className={styles.buttons}
                    color='primary'
                    disabled={
                      isAssistant
                        ? !checked || !patientSelected.patient
                        : !checked // || consentFile === null
                    }
                    onClick={handleCreateAppointment}
                  >
                    Crear consulta
                  </Button>
                </Grid>
              </div>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

const mapStateToProps = ({ session, user, appointments, doctors }) => {
  return {
    session,
    userData: user,
    appointmentsData: appointments,
    doctors,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUser: (type, id, token) =>
    dispatch({
      type: userActionsTypes.GET_USER,
      payload: { type, id, token },
    }),
  addUserInfo: (type, data, newValue) =>
    dispatch({
      type: userActionsTypes.ADD_INFO_USER,
      payload: { type, data, newValue },
    }),
  createInfo: (type, body, data) =>
    dispatch({
      type: userActionsTypes.CREATE_INFORMATION,
      payload: { type, body, data },
    }),
  deleteUserInfo: (type, data, valueId) =>
    dispatch({
      type: userActionsTypes.DELETE_INFO_USER,
      payload: { type, data, valueId },
    }),
  deleteMessages: () =>
    dispatch({
      type: appointmentActionsTypes.DELETE_MESSAGES,
    }),
  createAppointment: (
    scheduleId,
    price,
    reason,
    doctor,
    patient,
    token,
    allergiesObjects,
    medicationsObjects,
    diseasesObjects,
    injuredArea,
    physicalExamination,
    symptoms,
    symptomsTime,
    spo2,
    glucose,
    systolicPressure,
    diastolicPressure,
    heartRate,
    temperature,
    expNum,
    respiratoryRate,
    consentFile
  ) =>
    dispatch({
      type: appointmentActionsTypes.CREATE_APPOINTMENT,
      payload: {
        scheduleId,
        price,
        reason,
        doctor,
        patient,
        token,
        allergiesObjects,
        medicationsObjects,
        diseasesObjects,
        injuredArea,
        physicalExamination,
        symptoms,
        symptomsTime,
        spo2,
        glucose,
        systolicPressure,
        diastolicPressure,
        heartRate,
        temperature,
        expNum,
        respiratoryRate,
        consentFile,
      },
    }),
  uploadAppointmentFiles: (body) =>
    dispatch({
      type: appointmentActionsTypes.UPLOAD_APPOINTMENT_FILES,
      payload: { body },
    }),
  uploadConsentFile: (body) =>
    dispatch({
      type: appointmentActionsTypes.UPLOAD_APPOINTMENT_CONSENT_FILE,
      payload: { body },
    }),
  deleteAttachmentMessages: () =>
    dispatch({
      type: appointmentActionsTypes.DELETE_ATTACHMENT_MESSAGES,
    }),
  getPatients: (queryParams, queryValues) =>
    dispatch({
      type: userActionsTypes.GET_PATIENTS,
      payload: { queryParams, queryValues },
    }),
  deleteSchedule: (token, scheduleId, isMultiple) =>
    dispatch({
      type: appointmentActionsTypes.DELETE_SCHEDULE,
      payload: {
        token,
        scheduleId,
        isMultiple,
      },
    }),
  getMpPreference: (body) =>
    dispatch({
      type: userActionsTypes.GET_USER_MP_PREFERENCE,
      payload: { body },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Appointment);
